import React from 'react';
import Questions from '../Questions';
import PlussMobil from '../CollaborationPartner';
import { useCmsText } from '../../hooks/useCmsText';

const ThankYouPage = () => {
  const { renderPlainText: renderText  } = useCmsText();
  
  return (
    <div className='w-full md:w-2/3 lg:w-1/3 mx-auto flex flex-col px-4 md:px-8 lg:px-12 py-5'>
      <div className='font-medium mt-20 text-center text-5xl text-primary'>
        {renderText('thankyou_message', 'Takk for tilbakemeldingen!')}
      </div>
      <Questions />
      <PlussMobil />
    </div>
  )
}

export default ThankYouPage;